<template>
  <div class="home">
    <HomeHeader class="home-header" ></HomeHeader>
    <HomeNav class="home-nav"></HomeNav>
    <HomeSwiper class="home-poster"></HomeSwiper>
    <HomeAbout class="home-about"></HomeAbout>
    <HomeMain class="home-main"></HomeMain>
    <HomeNews class="home-news"></HomeNews>
    <HomeQuality class="home-quality"></HomeQuality>
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import HomeHeader from '../../common/header/Header'
import HomeNav from '../../common/navigation/Navigation'
import HomeSwiper from './components/Swiper'
import HomeAbout from './components/About'
import HomeMain from './components/Main'
import HomeNews from './components/News'
import HomeQuality from './components/Quality'
import HomeFooter from '../../common/footer/Footer'
export default {
  name: 'home',
  components: {
    HomeHeader, HomeNav, HomeSwiper, HomeAbout, HomeMain, HomeNews, HomeQuality, HomeFooter
  },
  data () {
    return {
      swiperList: [],
      newsList: [],
      screenWidth: document.body.clientWidth
    }
  },
  methods: {
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        this.$router.go(0)
      })()
    }
  }
}
</script>

<style scoped lang="stylus">
@import "~styles/varibles.styl"
.home
  position relative
  .home-nav
    position absolute
    top 150px
    left 0
    z-index 2
    width 100%
  .home-poster
    position relative

</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue